DOMReady( function(){
  /* ========================================================================
  * diapo v2 page view
  * ======================================================================== */
  if( document.querySelector('.type-diaporama') && document.querySelectorAll('.diapo').length > 0 )
  {
    [... document.querySelectorAll('.diapo')].map( diapoEl => {
      new IntersectionObserver( function (entries, observer ) {
        entries.forEach((entry) => {
          if ( entry.isIntersecting ) {
            console.log( 'Diapo pageview' );
            if( typeof dataLayer !== undefined ) {
              dataLayer.push({event:"pageview-dynamic"})
            }
            if( typeof _wsq !== undefined ) {
              _wsq.push(['_wysistat']);
            }
          }
        });
      }).observe(diapoEl);
    });
  }
});